<template>
    <q-select outlined :modelValue="modelValue" :label="label" @update:modelValue="setPlace($event)" use-input
        hide-selected fill-input input-debounce="1000" :options="options" @filter="filterFn"
        @filter-abort="abortFilterFn" :error="error">
        <template v-slot:option="scope">
            <q-item v-bind="scope.itemProps">
                <q-item-section>
                    <q-item-label>{{ scope.opt.label }}</q-item-label>
                </q-item-section>
            </q-item>
        </template>
        <template v-slot:no-option>
            <q-item>
                <q-item-section class="text-grey">
                    No results
                </q-item-section>
            </q-item>
        </template>
        <template v-slot:error>
            <span v-for="err in errors" :key="err">{{ err }}</span>
        </template>
        <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope || {}" />
        </template>
    </q-select>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue'

onMounted(async () => {
    const { AutocompleteService } = await google.maps.importLibrary("places");
    predictionService.value = new AutocompleteService();
});

const props = defineProps({
    modelValue: [String, Number],
    errors: [String, Array],
    label: [String]
});
const emit = defineEmits(['update:modelValue']);
const options = ref([]);
const error = computed(() => props?.errors && props?.errors?.length !== 0)
const abortFilterFn = () => console.log('delayed filter aborted')
const predictionService = ref(null);

const filterFn = async (val, update, abort) => {
    if (!val || val.length < 3) {
        abort()
        return []
    };
    if (!predictionService.value) return;
    predictionService.value.getPlacePredictions(
        {
            input: val,
            componentRestrictions: { country: "ar" },
        },
        (predictions) => {
            update(() => options.value = predictions.map((p) => ({
                label: p.description,
                value: p.place_id,
            })));
        }
    );

}

const setPlace = async (place) => {
    if (!place) return;
    let geocoder = new google.maps.Geocoder();
    await geocoder.geocode({ placeId: place.value }, (results, status) => {
        if (status === "OK") {
            if (results[0]) {
                emit('update:modelValue', results[0]);
            } else {
                window.alert("No results found");
            }
        } else {
            window.alert("Geocoder failed due to: " + status);
        }
    });
};
</script>
